import BarekamText from "../../../../pages/components/text";
import BarekamButton, {DialogButtons} from "../../../../pages/components/button";
import React, {useEffect, useState} from "react";
import Message from "../../../../pages/components/message";
import {MessageSections} from "../../../../pages/components/message/message";
import {DialogButtonContainer} from "../../../../pages/components/dialogs/standard-dialog/styled";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    timelineItemClasses,
    TimelineSeparator
} from "@mui/lab";
import historyService from "../../../../services/history.service";
import {AuditModel} from "../../../../pages/shared/models/AuditModel";
import moment from "moment";
import {HistoryDialogContent} from "./shared/styled";

export const History = ({category, categoryId, onClose, type}: HistoryDialogProps) => {
    const [history, setHistory] = useState<any[]>([]);

    useEffect(() => {
        historyService.getHistoryByCategoryId(category, categoryId, {updatedFields: getFields()})
            .then(result => {
                setHistory(result)
            })
    }, [])

    function getFields() {
        switch (type) {
            case HistoryPopupType.LOCATION:
                return ['depot', 'sector', 'corridor', 'rack', 'bin']
            case HistoryPopupType.STATUS:
                return ['trackRecord']
            case HistoryPopupType.BALANCE:
                return ['amount', 'topUpReason', 'paymentId']
            default:
                return undefined
        }
    }

    const Row = ({audit}: {audit: AuditModel}) => {
        const updateData = audit.updatedDocument;

        switch (type) {
            case HistoryPopupType.LOCATION:
                return (
                    <TimelineContent>
                        <BarekamText variant={'m'} bold>
                            {[updateData.depot, updateData.sector, updateData.corridor, updateData.rack, updateData.bin].join(' / ')}
                        </BarekamText>

                        <BarekamText variant={'m'} opaque>
                            {`${moment(audit.updatedOn).format('DD/MM/YYYY HH:mm')}, ${audit.updatedBy.firstName} ${audit.updatedBy.lastName}, ${audit.updatedBy.warehouse?.city || ''}`}
                        </BarekamText>
                    </TimelineContent>
                )
            case HistoryPopupType.STATUS:
                const latestStatusKey = audit.updatedDocument.trackRecord[0].state.name;

                return (
                    <TimelineContent>
                        <BarekamText variant={'m'} bold>
                            <Message messageKey={latestStatusKey} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>

                        <BarekamText variant={'m'} opaque>
                            {`${moment(audit.updatedOn).format('DD/MM/YYYY HH:mm')}, ${audit.updatedBy.firstName} ${audit.updatedBy.lastName}, ${audit.updatedBy.warehouse?.city || ''}`}
                        </BarekamText>
                    </TimelineContent>
                )
            case HistoryPopupType.BALANCE:
                if (audit && audit.updatedFields) {
                    return (
                        <TimelineContent>
                            {Object.keys(audit.updatedFields).map(field => {
                                if (field !== 'updatedBy') {
                                    return (
                                        <BarekamText variant={'m'} bold>
                                        <Message messageKey={field} sectionId={MessageSections.MAIN}/>
                                        {`: ${audit.updatedFields[field]}`}
                                    </BarekamText>
                                    )
                                } else {
                                    return <></>
                                }
                            })}

                            <BarekamText variant={'m'} opaque>
                                {`${moment(audit.updatedOn).format('DD/MM/YYYY HH:mm')}, ${audit.updatedBy.firstName} ${audit.updatedBy.lastName}`}
                            </BarekamText>
                        </TimelineContent>
                    )
                } else {
                    return <></>
                }
            default:
                return (
                    <TimelineContent>
                        {audit && audit.updatedFields && Object.keys(audit?.updatedFields).map(field =>
                            <BarekamText variant={'m'} bold>
                                <Message messageKey={field} sectionId={MessageSections.MAIN}/>
                                {`: ${audit.updatedFields[field]}`}
                            </BarekamText>
                        )}

                        <BarekamText variant={'m'} opaque>
                            {`${moment(audit.updatedOn).format('DD/MM/YYYY HH:mm')}, ${audit.updatedBy.firstName} ${audit.updatedBy.lastName}, ${audit.updatedBy.warehouse?.city || ''}`}
                        </BarekamText>
                    </TimelineContent>
                )
        }
    }

    return (
        <>
            <HistoryDialogContent>
                <Timeline sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 1,
                    },
                }}>
                    {history.map(item => (
                        <TimelineItem>
                            <TimelineSeparator>
                                <TimelineDot />
                                <TimelineConnector sx={{
                                    backgroundColor: 'unset',
                                    borderRight: '2px dotted #bdbdbd'
                                }}/>
                            </TimelineSeparator>

                            <Row audit={item}/>
                        </TimelineItem>
                    ))}
                </Timeline>
            </HistoryDialogContent>

            <DialogButtonContainer>
                <BarekamButton type={DialogButtons.OK} onClick={() => onClose()}>
                    <BarekamText variant={'s'} fontWeight={700} align={"center"}>
                        <Message messageKey={'close'} sectionId={MessageSections.MAIN}/>
                    </BarekamText>
                </BarekamButton>
            </DialogButtonContainer>
        </>
    )
}

interface HistoryDialogProps {
    category: string,
    categoryId: number,
    onClose: () => void,
    type: HistoryPopupType;
}

export enum HistoryPopupType {
    ALL_ORDER_FIELDS,
    LOCATION,
    STATUS,
    BALANCE
}